module.exports = __webpack_public_path__ + "img/auto-responder.298f4f18.svg";